// Client-side image processing: downscale + JPEG re-encode so uploads stay small
// and the AI vision call is fast (raw phone photos are multiple MB).

async function fileToImage(file) {
  const dataUrl = await new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = dataUrl;
  });
  return { img, dataUrl };
}

function resizeCanvas(img, maxDim) {
  let { width, height } = img;
  if (width > maxDim || height > maxDim) {
    const scale = Math.min(maxDim / width, maxDim / height);
    width = Math.round(width * scale);
    height = Math.round(height * scale);
  }
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d").drawImage(img, 0, 0, width, height);
  return canvas;
}

function canvasToBlob(canvas, quality) {
  return new Promise((res) => canvas.toBlob((b) => res(b), "image/jpeg", quality));
}

// Produce everything needed to store one uploaded photo in cloud object storage:
//  - cardBlob (~820px): light JPEG shown in grids/thumbnails
//  - fullBlob (~1440px): crisp JPEG for the detail page (~1080p+)
//  - cardDataUrl: base64 of the card image, sent to the AI vision call (which needs bytes)
//  - blur (~28px base64, ~1KB): instant blur-up placeholder stored inline in the DB
export async function prepareUpload(file) {
  const { img } = await fileToImage(file);
  const cardCanvas = resizeCanvas(img, 820);
  const fullCanvas = resizeCanvas(img, 1440);
  const [cardBlob, fullBlob] = await Promise.all([
    canvasToBlob(cardCanvas, 0.72),
    canvasToBlob(fullCanvas, 0.78),
  ]);
  return {
    cardBlob,
    fullBlob,
    cardDataUrl: cardCanvas.toDataURL("image/jpeg", 0.72),
    blur: resizeCanvas(img, 28).toDataURL("image/jpeg", 0.5),
  };
}
